import classes from "./FoodReviewPage.module.css";
import { isLoggedIn } from "../util/getToken";
import domain from "../domain";
import { useState } from "react";
import FoodReviewComponent from "../components/foodReviewPage/FoodReviewComponent";
import NoDataComponent from "../components/NoDataComponent";
import PageContent from "../components/PageContent";
import {
  extractData as getData,
  getMergedTagDatalocallyById,
  tabulateData,
} from "../util/foodReview/extractData";
import {
  getActiveBranchIds1,
  getAllBranchIds,
  getBranchInfobyId,
} from "../util/multipleBranch/getActiveBranchId";

async function fetchData() {
  //console.log("Fetching mergedTags Data from DB");
  // we send all branches ids as body.
  const branches = getAllBranchIds();
  //console.log(branches);
  if (!isLoggedIn()) return;
  try {
    const data1 = await fetch(`${domain}/api/fetchMergedFtags`, {
      method: "Post",
      body: JSON.stringify({
        branches: branches,
      }),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await data1.json();
    //console.log(data);
    return data;
  } catch (err) {}
}

export default function FoodReviewPage() {
  //console.log("rendering food page");

  async function go(setIsMergedDataPresentLocally) {
    //console.log("go funct");
    try {
      //if pdata is  not present in local storage then fetch from DB

      const data = await fetchData();
      //console.log(data);
      if (data != undefined) {
        sessionStorage.setItem("mergedTagsData", JSON.stringify(data));

        setIsMergedDataPresentLocally((p) => true);
      }
    } catch (err) {
      //console.log("hip1");
      //console.log(err);
    }
  }
  //console.log("dd");
  let selfId = localStorage.getItem("id");
  let BID = JSON.parse(localStorage.getItem("branches"))[0].bId;
  let mergedTags = getMergedTagDatalocallyById(BID);
  //console.log(mergedTags);
  const [isMergedDataPresentLocally, setIsMergedDataPresentLocally] =
    useState(false);
  // //console.log(mergedTags);
  if (mergedTags == null) {
    go(setIsMergedDataPresentLocally);
    return <NoDataComponent />;
  }
  let data1 = JSON.parse(sessionStorage.getItem("mainData"));

  if (data1 == null) return <NoDataComponent />;
  // first i will have to extract feedback where food rating is given poor.
  let data3;

  const data2 = getData(data1); // this function only filter feedbacks
  data3 = tabulateData(data2);

  //console.log(data2);
  //console.log(data3);
  let branches = JSON.parse(localStorage.getItem("branches"));
  const activeBranches = getActiveBranchIds1();

  return (
    <>
      <PageContent>
        <h3>Food Review Page</h3>
        {activeBranches.map((bId, index) => {
          return (
            <div key={`${index}cut`} className={classes.branchContainer}>
              {branches.length > 1 && <h4>{getBranchInfobyId(bId).name}</h4>}
              <div>
                <FoodReviewComponent data={data3[index].data} bId={bId} />
              </div>
            </div>
          );
        })}
      </PageContent>
    </>
  );
}
